(function ($) {

  $(window).on('load', function () {

    //
    // When close button is clicked hide this message
    //
    $(document).on('click', '.messages button.message-close', function (event) {
      $(this).parent().fadeOut("slow", function () {
        $(this).remove();
      });
    });

  });

}(jQuery));
